import { useSelector } from 'store';

const useUser = () => useSelector((state) => state.auth.user);

export default useUser;
